import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { LANDING } from 'constants/testIds';

const CREATORS = [
  { name: 'Kirti Gupta', role: 'Model', img: '/creators/kirti-gupta-avatar.jpg' },
  { name: 'Sehej Bhasin', role: 'Photographer', img: '/creators/sehej-bhasin-avatar.webp' },
  { name: 'Gursimarh Anand', role: 'Social Media', img: '/creators/gursimarh-anand-avatar.jpg' },
  { name: 'Varad Kulkarni', role: 'Cinematographer', img: '/creators/varad-kulkarni-avatar.jpg' },
  { name: 'Gautam Jagdev', role: 'Fashion Creator', img: '/creators/gautam-jagdev-avatar.jpg' },
  { name: 'Prabhnoor Singh', role: 'Cinematographer', img: '/creators/prabhnoor-singh-avatar.jpg' },
];

const CreatorCard = ({ c, i }) => (
  <motion.a
    href="#"
    data-testid={LANDING.communityCard(i)}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.6, delay: (i % 6) * 0.05, ease: [0.22, 1, 0.36, 1] }}
    className="group flex flex-col items-center text-center"
  >
    <div className="relative">
      <div className="absolute -inset-1 rounded-full bg-[#6C63F5]/0 group-hover:bg-[#6C63F5]/30 blur-md transition-colors duration-500" />
      <div className="relative h-28 w-28 md:h-32 md:w-32 rounded-full overflow-hidden ring-2 ring-zinc-800 group-hover:ring-[#6C63F5] transition-[transform,box-shadow] duration-500 group-hover:-translate-y-1">
        <img
          src={c.img}
          alt={`${c.name} — ${c.role}`}
          loading="lazy"
          className="w-full h-full object-cover object-center transition-transform duration-1000 ease-out group-hover:scale-[1.06]"
        />
      </div>
    </div>
    <div className="mt-4 font-display text-base md:text-[1.05rem] font-semibold tracking-tight text-zinc-50 leading-tight">
      {c.name}
    </div>
    <div className="mt-1 text-xs md:text-sm text-zinc-500">
      {c.role}
    </div>
  </motion.a>
);

export const CommunityShowcase = () => {
  const navigate = useNavigate();

  return (
    <section
      id="community"
      data-testid={LANDING.communitySection}
      className="relative py-24 md:py-36 bg-zinc-950 border-t border-zinc-900"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl mb-16 md:mb-20">
          <div className="text-xs uppercase tracking-[0.2em] text-[#6C63F5] font-medium mb-4">
            Real members
          </div>
          <h2 className="font-display font-bold text-4xl md:text-6xl leading-[0.98] tracking-tighter text-zinc-50">
            The people already
            <br />
            <span className="text-zinc-500">building on Qreativs.</span>
          </h2>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-7 gap-6 md:gap-8">
          {CREATORS.map((c, i) => (
            <CreatorCard key={c.name} c={c} i={i} />
          ))}

          <motion.button
            type="button"
            onClick={() => navigate('/signup')}
            data-testid="landing-community-more"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="group flex flex-col items-center text-center"
          >
            <div className="relative h-28 w-28 md:h-32 md:w-32 rounded-full flex items-center justify-center bg-[#6C63F5]/10 ring-2 ring-dashed ring-[#6C63F5]/40 group-hover:ring-[#6C63F5] group-hover:bg-[#6C63F5]/15 transition-colors">
              <span className="font-display font-bold text-2xl md:text-3xl text-[#8b83ff] tracking-tight">
                +5,000
              </span>
            </div>
            <div className="mt-4 font-display text-base md:text-[1.05rem] font-semibold tracking-tight text-zinc-50 leading-tight">
              more users
            </div>
            <div className="mt-1 text-xs md:text-sm text-zinc-500">
              Join the community
            </div>
          </motion.button>
        </div>
      </div>
    </section>
  );
};

export default CommunityShowcase;
